import type * as Types from '../../../../../graphql/base-types.graphql';

import { gql } from '@apollo/client';
import { CdFieldsFragmentDoc } from '../../../../../graphql/gql-fragments/company-director.graphql';
import { MpFieldsFragmentDoc } from '../../../../../graphql/gql-fragments/meeting-participant.graphql';
import { IdentityFieldsFragmentDoc } from '../../../../../graphql/gql-fragments/identity.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GqlShmFunctionSelectQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
}>;


export type GqlShmFunctionSelectQuery = { companyDirectors: Array<{ id: string, registeredAbroad: boolean, invited: boolean, identityId: string, functions: Array<any>, companyId: string, createdAt: string, updatedAt: string }> };

export type GqlMpSetFunctionsMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  input: Types.GqlMpSetFunctionsInput;
}>;


export type GqlMpSetFunctionsMutation = { mpSetFunctions: Array<{ id: string, initials?: string | null, chairman: boolean, secretary: boolean, adjuster: boolean, present: boolean, summoned?: boolean | null, position?: string | null, isShareholder: boolean, kind: Types.GqlMpKind, proxyId?: string | null, meetingId?: string | null, identityId: string, createdAt: string, updatedAt: string }> };

export type GqlCreateMeetingParticipantMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  input: Types.GqlMpCreateInput;
}>;


export type GqlCreateMeetingParticipantMutation = { createMeetingParticipant: { id: string, initials?: string | null, chairman: boolean, secretary: boolean, adjuster: boolean, present: boolean, summoned?: boolean | null, position?: string | null, isShareholder: boolean, kind: Types.GqlMpKind, proxyId?: string | null, meetingId?: string | null, identityId: string, createdAt: string, updatedAt: string, identity: { id: string, identityNumberKind: number, identityNumber: string, juridicalKind: number, name: string, email?: string | null, emailMd5?: string | null, phone?: string | null, countryCode?: string | null, address?: string | null, userId?: string | null, isSwedish: boolean, createdAt: string, updatedAt: string, companyId: string } } };


export const ShmFunctionSelectDocument = gql`
    query ShmFunctionSelect($companyId: ID!) {
  companyDirectors(companyId: $companyId) {
    ...CdFields
  }
}
    ${CdFieldsFragmentDoc}`;

/**
 * __useShmFunctionSelectQuery__
 *
 * To run a query within a React component, call `useShmFunctionSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useShmFunctionSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShmFunctionSelectQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useShmFunctionSelectQuery(baseOptions: Apollo.QueryHookOptions<GqlShmFunctionSelectQuery, GqlShmFunctionSelectQueryVariables> & ({ variables: GqlShmFunctionSelectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlShmFunctionSelectQuery, GqlShmFunctionSelectQueryVariables>(ShmFunctionSelectDocument, options);
      }
export function useShmFunctionSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlShmFunctionSelectQuery, GqlShmFunctionSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlShmFunctionSelectQuery, GqlShmFunctionSelectQueryVariables>(ShmFunctionSelectDocument, options);
        }
export function useShmFunctionSelectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GqlShmFunctionSelectQuery, GqlShmFunctionSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GqlShmFunctionSelectQuery, GqlShmFunctionSelectQueryVariables>(ShmFunctionSelectDocument, options);
        }
export type ShmFunctionSelectQueryHookResult = ReturnType<typeof useShmFunctionSelectQuery>;
export type ShmFunctionSelectLazyQueryHookResult = ReturnType<typeof useShmFunctionSelectLazyQuery>;
export type ShmFunctionSelectSuspenseQueryHookResult = ReturnType<typeof useShmFunctionSelectSuspenseQuery>;
export type ShmFunctionSelectQueryResult = Apollo.QueryResult<GqlShmFunctionSelectQuery, GqlShmFunctionSelectQueryVariables>;
export const MpSetFunctionsDocument = gql`
    mutation MpSetFunctions($companyId: ID!, $input: MpSetFunctionsInput!) {
  mpSetFunctions(companyId: $companyId, input: $input) {
    ...MpFields
  }
}
    ${MpFieldsFragmentDoc}`;
export type GqlMpSetFunctionsMutationFn = Apollo.MutationFunction<GqlMpSetFunctionsMutation, GqlMpSetFunctionsMutationVariables>;

/**
 * __useMpSetFunctionsMutation__
 *
 * To run a mutation, you first call `useMpSetFunctionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMpSetFunctionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mpSetFunctionsMutation, { data, loading, error }] = useMpSetFunctionsMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMpSetFunctionsMutation(baseOptions?: Apollo.MutationHookOptions<GqlMpSetFunctionsMutation, GqlMpSetFunctionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlMpSetFunctionsMutation, GqlMpSetFunctionsMutationVariables>(MpSetFunctionsDocument, options);
      }
export type MpSetFunctionsMutationHookResult = ReturnType<typeof useMpSetFunctionsMutation>;
export type MpSetFunctionsMutationResult = Apollo.MutationResult<GqlMpSetFunctionsMutation>;
export type MpSetFunctionsMutationOptions = Apollo.BaseMutationOptions<GqlMpSetFunctionsMutation, GqlMpSetFunctionsMutationVariables>;
export const CreateMeetingParticipantDocument = gql`
    mutation CreateMeetingParticipant($companyId: ID!, $input: MpCreateInput!) {
  createMeetingParticipant(companyId: $companyId, input: $input) {
    ...MpFields
    identity {
      ...IdentityFields
    }
  }
}
    ${MpFieldsFragmentDoc}
${IdentityFieldsFragmentDoc}`;
export type GqlCreateMeetingParticipantMutationFn = Apollo.MutationFunction<GqlCreateMeetingParticipantMutation, GqlCreateMeetingParticipantMutationVariables>;

/**
 * __useCreateMeetingParticipantMutation__
 *
 * To run a mutation, you first call `useCreateMeetingParticipantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMeetingParticipantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMeetingParticipantMutation, { data, loading, error }] = useCreateMeetingParticipantMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMeetingParticipantMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateMeetingParticipantMutation, GqlCreateMeetingParticipantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateMeetingParticipantMutation, GqlCreateMeetingParticipantMutationVariables>(CreateMeetingParticipantDocument, options);
      }
export type CreateMeetingParticipantMutationHookResult = ReturnType<typeof useCreateMeetingParticipantMutation>;
export type CreateMeetingParticipantMutationResult = Apollo.MutationResult<GqlCreateMeetingParticipantMutation>;
export type CreateMeetingParticipantMutationOptions = Apollo.BaseMutationOptions<GqlCreateMeetingParticipantMutation, GqlCreateMeetingParticipantMutationVariables>;